<script>import { onDestroy } from "svelte";
import SVG from "../elements/SVG.svelte";
import ButtonBoxPrimary from "../elements/buttons/variants/ButtonBoxPrimary.svelte";
import ButtonTextPrimary from "../elements/buttons/variants/ButtonTextPrimary.svelte";
export let props;
const closeBanner = () => {
  props = void 0;
};
const handleCloseBanner = () => {
  if (props?.closeAction) {
    props.closeAction();
  }
  closeBanner();
};
onDestroy(() => {
  closeBanner();
});
</script>

{#if props}
	<div
		class="p-2 md:p-4 {props.classNames} {props.bgColorClassName ?? 'bg-white'}"
	>
		<div
			class="container flex gap-4 {props.ctaLabel
				? 'flex-wrap'
				: ''} items-center justify-between {props.textColor ? `text-${props.textColor}` : ''}"
		>
			<div class="flex items-center flex-1 gap-4 {props.isCentered ? 'justify-center' : ''}">
				{#if props.iconName}
					<div class="{props.iconColor ? `text-${props.iconColor}` : ''} flex-shrink-0">
						<SVG name={props.iconName} size="big" />
					</div>
				{/if}
				<div>
					{@html props.message}
				</div>
			</div>
			{#if props.ctaLabel}
				<div
					class="mt-2 md:mt-0 md:mr-4 order-last md:order-none {props.ctaLabel
						? 'w-full md:w-auto'
						: ''} flex-shrink-0"
				>
					{#if props.ctaUrl}
						{#if props.ctaAppearance === 'text'}
							<ButtonTextPrimary
								props={{
									label: props.ctaLabel,
									href: props.ctaUrl,
									hrefTarget: props.ctaUrlTargetBlank ? 'blank' : 'self',
									size: 'tiny',
									classNames: props.ctaLabel ? 'w-full md:w-auto' : ''
								}}
							/>
						{:else}
							<ButtonBoxPrimary
								props={{
									label: props.ctaLabel,
									href: props.ctaUrl,
									hrefTarget: props.ctaUrlTargetBlank ? 'blank' : 'self',
									size: 'tiny',
									classNames: props.ctaLabel ? 'w-full md:w-auto' : ''
								}}
							/>
						{/if}
						<ButtonBoxPrimary />
					{/if}
					{#if props.ctaAction}
						{#if props.ctaAppearance === 'text'}
							<ButtonTextPrimary
								onClick={props.ctaAction}
								props={{
									label: props.ctaLabel,
									size: 'tiny',
									classNames: props.ctaLabel ? 'w-full md:w-auto' : ''
								}}
							/>
						{:else}
							<ButtonBoxPrimary
								onClick={props.ctaAction}
								props={{
									label: props.ctaLabel,
									size: 'tiny',
									classNames: props.ctaLabel ? 'w-full md:w-auto' : ''
								}}
							/>
						{/if}
					{/if}
				</div>
			{/if}
			<div on:click={() => handleCloseBanner()} class="cursor-pointer flex-shrink-0">
				<SVG name="close" />
			</div>
		</div>
	</div>
{/if}
